import { CheckedAddress } from '@sparkdotfi/common-universal'

import { allowanceQueryKey } from '../../approve/logic/query'
import { StakeSpkAction } from '../types'
import { spkStakingModuleAddress, spkStakingModuleConfig } from '@/config/contracts-generated'
import { getContractAddress } from '@/domain/hooks/useContractAddress'
import { getBalancesQueryKeyPrefix } from '@/domain/wallet/getBalancesQueryKeyPrefix'
import { ensureConfigTypes } from '@/features/actions/logic/transactions/useWrite'
import { ActionConfig, ActionContext } from '@/features/actions/logic/types'
import { spkStakeAmountQueryKey } from '@/features/spk/airdrop/logic/spkStakeAmountQuery'
import { spkStakingDataQueryKey } from '@/features/spk/staking/logic/useSpkStakingData'

export function createStakeSpkActionConfig(action: StakeSpkAction, context: ActionContext): ActionConfig {
  const { account, chainId } = context
  const vault = getContractAddress(spkStakingModuleAddress, chainId)

  return {
    getWriteConfig: () => {
      const { spk } = action
      const amount = spk.toBigInt(action.amount)

      return ensureConfigTypes({
        address: vault,
        abi: spkStakingModuleConfig.abi,
        functionName: 'deposit',
        args: [account, amount],
      })
    },

    invalidates: () => {
      return [
        allowanceQueryKey({ token: action.spk.address, spender: vault, account, chainId }),
        getBalancesQueryKeyPrefix({ account, chainId }),
        spkStakingDataQueryKey({ account, chainId }),
        spkStakeAmountQueryKey({ address: CheckedAddress(account), chainId }),
      ]
    },
  }
}
